import React from "react";
import PropTypes from "prop-types";
import { Scope } from "informed";

import { Container, Font } from ".";

const Texts = ({ themeData, scopePicked, primaryState, checkForEmptyValues }) => {
	const currentElementType = themeData.texts[scopePicked];
	const states = Object.keys(currentElementType);
	return (
		<div className="theme-columns">
			{states.map(state => {
				const primaryStatePath = `texts.${scopePicked}.${primaryState}`;
				const currentStatePath = `texts.${scopePicked}.${state}`;
				return (
					<Scope scope={state} key={state}>
						<div className="theme-column">
							<h4 className="header">{state}</h4>
							<div className="theme-content">
								<Scope scope="font">
									<Font
										state={state}
										checkForEmptyValues={checkForEmptyValues}
										primaryStatePath={primaryStatePath}
										currentStatePath={currentStatePath}
									/>
								</Scope>
								<Container
									state={state}
									checkForEmptyValues={checkForEmptyValues}
									primaryStatePath={primaryStatePath}
									currentStatePath={currentStatePath}
								/>
							</div>
						</div>
					</Scope>
				);
			})}
		</div>
	);
};

Texts.propTypes = {
	checkForEmptyValue: PropTypes.func.isRequired,
	primaryState: PropTypes.string.isRequired,
	scopePicked: PropTypes.string.isRequired,
	themeData: PropTypes.object.isRequired,
};

export default Texts;
